import { PrintType, StoreFont } from '@/types';
import { isDigital } from '@/model/printType/isDigital';
import { ptToMm } from '../math/ptToMm';

export const getMinFontSize = (printType: PrintType, font: StoreFont) => {
  return isDigital(printType) ? ptToMm(10) : font.minimalSize;
};
